module.exports = __webpack_public_path__ + "assets/188e2416d2daa770e2add1bc9e73f0ca.png";